export default "__VITE_ASSET__2513391b__"